document.addEventListener('DOMContentLoaded', function () {
  // Scroll-to-tab link handler for fitment notice links
  document.querySelectorAll('.fitment-notice-link').forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();

      var isDesktop = window.innerWidth >= 768;

      if (isDesktop) {
        var tabBtn = document.querySelector('[data-target="fitmentnoticedata"]');
        if (tabBtn) tabBtn.click();
      } else {
        var accBtn = document.getElementById('fitmentnotice');
        if (accBtn) accBtn.click();
      }

      var target = document.getElementById('fitmentnoticedata');
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });
});
